
import Tools from './tools.js'

export class UU5String {
  constructor(str) {
    this._innerString = str;
    this._childrenArray = Tools.getChildrenFromUu5String(str);
  }
  get innerString() {return this._innerString}
  set innerString(str) {
    if (this._innerString !== str) {
      this._childrenArray = Tools.getChildrenFromUu5String(str);
      this._innerString = str;
    }
  }
  get childrenArray() {
    return this._childrenArray;
  }
  getClass() {
    return this.constructor.name;
  }
  clone() {
    return new UU5String(this._innerString);
  }
}

export default UU5String;


// WEBPACK FOOTER //
// ./common/uu5-string.js